import React, {useState} from 'react'

import VideoPlayer from '../videoPlayer'
import Pdf from '../pdf'
import './linksBoxItem.css'

export default function LinksBoxItem({url, image, type, title, subheader, video, subtitles, pdf}) {
    const [videoIsOpen, setVideoIsOpen] = useState(false)
    const [pdfIsOpen, setpdfIsOpen] = useState(false)

    const handleLink = (url, video, pdf) => {
        if(video){
            setVideoIsOpen(true)
        } else if(pdf){
            setpdfIsOpen(true)
        } else {
            window.open(url)
        }
    }

    const handleVideoPlayer = (isOpen) => {
        setVideoIsOpen(isOpen)
    }

    const handlePdfViewer = (isOpen) => {
        setpdfIsOpen(isOpen)
    }

    return (
        <>
            <div className="linksBoxItem" onClick={() => handleLink(url, video, pdf)}>
                <img src={image} alt={title} />
                <span className='type'>{type}</span>
                {title && (
                    <h3>{title}</h3>
                )}

                {subheader && (
                    <h4>{subheader}</h4>
                )}
            </div>
            {videoIsOpen && (
                <VideoPlayer 
                    url={video} 
                    title={title}
                    subheader={subheader}
                    subtitles={subtitles}
                    handleVideoPlayer={handleVideoPlayer}
                />
            )}
            {pdfIsOpen && (
                <Pdf 
                    url={pdf} 
                    handlePdfViewer={handlePdfViewer}
                />
            )}
        </>
    )
}